import { SVGProps } from "react";

interface SpinnerProps extends SVGProps<SVGSVGElement> {
  animationDuration?: string;
}

const Spinner = ({
  animationDuration = "900ms",
  ...otherProps
}: SpinnerProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={100}
    height={100}
    viewBox="0 0 212 212"
    fill="none"
    {...otherProps}
  >
    <path
      d="M4 100C4 47.336 47.336 4 100 4s96 43.336 96 96"
      style={{
        fill: "none",
        fillRule: "nonzero",
        stroke: "url(#a)",
        strokeWidth: 20,
      }}
      transform="translate(6 6)"
    />
    <path
      d="M196 100c0 52.664-43.336 96-96 96S4 152.664 4 100"
      style={{
        fill: "none",
        fillRule: "nonzero",
        stroke: "url(#b)",
        strokeWidth: 20,
      }}
      transform="translate(6 6)"
    />
    <path
      d="M4 100a95.24 95.24 0 0 1 0-2"
      style={{
        fill: "none",
        fillRule: "nonzero",
        stroke: "currentColor",
        strokeWidth: 20,
        strokeLinecap: "round",
      }}
      transform="translate(6 6)"
    />
    <defs>
      <linearGradient
        id="a"
        x1={0}
        x2={1}
        y1={0}
        y2={0}
        gradientTransform="matrix(192 0 0 192 4 4)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: "currentColor",
            stopOpacity: 0,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "currentColor",
            stopOpacity: 0.5,
          }}
        />
      </linearGradient>
      <linearGradient
        id="b"
        x1={0}
        x2={1}
        y1={0}
        y2={0}
        gradientTransform="matrix(192 0 0 192 4 100)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: "currentColor",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "currentColor",
            stopOpacity: 0.5,
          }}
        />
      </linearGradient>
    </defs>
    <animateTransform
      attributeName="transform"
      dur={animationDuration}
      from="0 0 0"
      repeatCount="indefinite"
      to="360 0 0"
      type="rotate"
    />
  </svg>
);
export default Spinner;
